import React, { createContext, ReactElement, useContext } from "react";
import { RoleType, UserMetadata } from "../data/UserMetadata";

// The initial value is not used as UserProvider is only rendered in App.tsx when props.user is defined
const UserContext = createContext<UserMetadata>({
  alias: "",
  role: RoleType.NONE,
});

const useUserContext = () => useContext(UserContext);

interface Props {
  children: ReactElement;
  user?: UserMetadata;
}
function UserProvider(props: Props): ReactElement {
  return (
    <UserContext.Provider value={props.user!}>
      {props.children}
    </UserContext.Provider>
  );
}

export { UserProvider, useUserContext };
